import Rating from "react-rating";
import React, {useState} from "react";
import { useFormikContext } from "formik";
import ErrorMessage from "../Input/ErrorrMessage";
import { labelName } from "../../utils/functions";
import TextFieldStyles from "../Input/TextField/TextField.module.css";


export default function StarRating({ field_label, displayLabel, parent, isRequired, initialValue }) {
  const { setFieldValue } = useFormikContext();
  const name = parent ? `${parent}.${field_label}` : field_label;
  const [rating, setRating] = useState(initialValue ? parseInt(initialValue) : 0);
  const handleRatingChange = (value) => {
    setRating(value);
    setFieldValue(name, value);
  };

  return (
    <div className={TextFieldStyles.inputContainer}>
      <div className="label-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <label htmlFor="textarea" className={TextFieldStyles.label}>
          {labelName(displayLabel || field_label)}
          {isRequired === "true" && <span style={{ color: '#d32f2f', padding: 0 }}>*</span>}
        </label>
      </div>
      <div style={{ maxWidth: "400px", fontFamily: "Arial, sans-serif" }}>
        <input type="hidden" name={name} value={rating} />
        <Rating
          initialRating={rating}
          onChange={(value) => handleRatingChange(value)}
          emptySymbol={
            <span style={{ fontSize: "30px", color: "#ccc", cursor: "pointer" }}>☆</span>
          }
          fullSymbol={
            <span style={{ fontSize: "30px", color: "#ffd700", cursor: "pointer" }}>★</span>
          }
          style={{ margin: "0px" }}
        />
        <div style={{ display: "flex", alignItems: "center", marginTop: "10px", fontSize: "14px" }}>
          <p style={{ marginRight: "5px", color: "#555" }}>({rating}) star rating</p>|
          <button
            type="button"
            onClick={() => handleRatingChange(0)}
            style={{
              marginLeft: "5px",
              padding: "5px 10px",
              backgroundColor: "#d32f2f",
              color: "#fff",
              border: "none",
              fontSize: "12px",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Reset
          </button>
        </div>
      </div>
      <ErrorMessage name={name} />
    </div>
  );
}
